<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="home-page">
      <Header :isRestoCompleto="!firstTime" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
        <main>

          <div class="row">
    <div class="col-2"  >
      <a href="#"   @click="goToPage('Especialidades', $event)" v-if="!firstTime" >
      <p class="h5 mb-2"> <b-icon-arrow-left></b-icon-arrow-left>Atrás</p>
    </a>
    </div>
    <div class="col-8">
      <h3>Cantidad y numero de comensales por mesa destinado a la aplicación</h3>
    </div>
    <div class="col-2">
      <a href="#" v-on:click="registrarMesa()" v-if="!firstTime">
      <p class="h5 mb-2">Siguiente<b-icon-arrow-right></b-icon-arrow-right></p>
    </a>
    </div>
  </div>

          

          <hr class="" />
          <div class="alert alert-primary" role="alert">
            Y ahora... la parte más importante para que los clientes puedan reservar en modo automático y on-line una mesa! <br>

Debes decirnos la cantidad de mesas que vas a dejar para la aplicación.
</div>
<div class="alert alert-primary" role="alert">

Importante el numero de mesas no es el total de mesas que tienes en tu establecimiento, si aquellas que se van a poder
reservar en modo on-line. <br>

Además de cuantas mesas es importante que especifiques para cuantos comensales es cada mesa: <br>

Las mesas para reservar on-line son para: <br>
hasta 2 personas <br>
hasta 4 personas <br>
hasta 6 personas <br>

Tu decides la cantidad de mesas por cada tipo que quieres dejar para la aplicación <br>

Pero no te preocupes, la cantidad de mesas disponibles para la reserva on-line es flexible y la puedes cambiar cuando quieras

</div>
          <form v-on:submit.prevent="registrarMesa">
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label offset-2">Mesas para 2</label>
              <div class="col-sm-4">
                <div class="input-group">
                  <input
                    v-model="form.cantidad_dos"
                    type="number"
                    class="form-control"
                    maxlength="5"
                    min="0"
                    oninput="validity.valid||(value='0')"
                  />
                  <span class="input-group-text">Cantidad</span>
                </div>
              </div>
            </div>
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label offset-2">Mesas para 4</label>
              <div class="col-sm-4">
                <div class="input-group">
                  <input
                    v-model="form.cantidad_cuatro"
                    type="number"
                    class="form-control"
                    min="0"
                    oninput="validity.valid||(value='0')"
                  />
                  <span class="input-group-text">Cantidad</span>
                </div>
              </div>
            </div>
            <div class="mb-5 row">
              <label class="col-sm-4 col-form-label offset-2">Mesas para 6</label>
              <div class="col-sm-4">
                <div class="input-group">
                  <input
                    v-model="form.cantidad_seis"
                    type="number"
                    class="form-control"
                    min="0"
                    oninput="validity.valid||(value='0')"
                  />
                  <span class="input-group-text">Cantidad</span>
                </div>
              </div>
            </div>
            <div class="mb-4 row">
              <span class="col-sm-4 col-form-label offset-2">Tiempo medio de ocupación de la mesa por reserva</span>
              <div class="col-sm-4">
                <div class="input-group">
                  

                  <select
                  class="form-control"
                  v-model="form.duracion">
                  <option value="1:00">
                     1:00
                  </option>
                  <option value="1:30">
                     1:30
                  </option>
                  <option value="2:00">
                     2:00
                  </option>

                </select>


                  <span class="input-group-text"
                  data-bs-toggle="tooltip"
                data-bs-html="true"
                data-bs-placement="right"
                :title="tooltipTiempoHtml" 

                  >Tiempo</span>
                </div>
              </div>
            </div>
            

            <div class="d-grid d-md-flex justify-content-md-center">
              <button class="btn btn-primary" type="submit" :disabled="isFormEnable"  v-if="!firstTime">
                Guardar cambios
              </button>
              <button class="btn btn-primary" @click="goToPage('Especialidades', $event)" v-if="firstTime">
                Anterior
              </button>
              <button class="btn btn-primary" type="submit" v-if="firstTime">
                Siguiente
              </button>
            </div>
          </form>
          <PopUp :show="success" @close="success = false; if(firstTime)goToPageFirstTime('Horarios')">
            <template #body>
              <p>{{ success_msg }}</p>
            </template>
          </PopUp>
          <PopUp :show="error" @close="error = false">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
        </main>
        <Footer />
      </div>
    </body>
  </html>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import { Tooltip } from 'bootstrap';
import axios from "axios";
import { cloneDeep, isEqual } from 'lodash'
export default {
  name: "RegistrarMesa",
  components: {
    Header,
    Footer,
    PopUp,
  },
  data: function () {
    return {
      firstTime: false,
      originalForm: {},
      form: {
        cantidad_dos: "",
        cantidad_cuatro: "",
        cantidad_seis: "",
        duracion: "",
      },
      usuario_email: "",
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      tooltips: [],
      tooltipTiempoHtml:"Este parametro es una media de cuanto permanece ocupada una mesa por cada reserva. O lo que lo mismo: el tiempo medio de ocupación de la mesa por cada reserva"
    };
  },
  beforeMount() {
    this.cargarMesas();
  },
  computed: {
    isFormEnable() {
      // check if it's original value
      if (!isEqual(this.form, this.originalForm)) return false;

      return true;
    }
  },
  mounted() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  
    tooltipTriggerList.forEach(tooltipTriggerEl => {
    const tooltipInstance = new Tooltip(tooltipTriggerEl, {
      placement: 'right', // Posiciona el tooltip a la derecha
      boundary: 'window'  // Asegura que el tooltip se muestre dentro de la ventana
    });
    this.tooltips.push(tooltipInstance);
    // Muestra el tooltip
    tooltipInstance.show();
  });
},
beforeDestroy() {
  this.tooltips.forEach(tooltip => {
    tooltip.hide(); // Esconde cada tooltip antes de destruir el componente
  });
},
  methods: {
    cargarMesas() {
      axios
        .get("/getMesasRegistradas")
        .then((data) => {
          if (data.status == 200) {
            data.data.mesasRegistradas.forEach((mesaRegistrada) => {
              if (mesaRegistrada.cantidad_max == 2) {
                this.form.cantidad_dos = mesaRegistrada.cantidad.toString();
              }
              if (mesaRegistrada.cantidad_max == 4) {
                this.form.cantidad_cuatro = mesaRegistrada.cantidad.toString();
              }
              if (mesaRegistrada.cantidad_max == 6) {
                this.form.cantidad_seis = mesaRegistrada.cantidad.toString();
              }
              if(mesaRegistrada.cantidad_max == 2) {
                if(mesaRegistrada.duracionComida=="1"){
                  this.form.duracion = "1:00"
                }else if(mesaRegistrada.duracionComida=="1.3"){
                  this.form.duracion = "1:30"
                }else if(mesaRegistrada.duracionComida=="2"){
                  this.form.duracion = "2:00"
                }
              
              }
            });
            this.originalForm = cloneDeep(this.form);
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });
    },
    registrarMesa() {
      if(this.form.duracion === ''|| this.form.cantidad_dos === '' || this.form.cantidad_cuatro === '' || this.form.cantidad_seis === '')
      {
        this.error = true;
        this.error_msg =
          "Complete todos los campos";
        return;
      }

      if(this.form.cantidad_dos == '0' && this.form.cantidad_cuatro == '0' && this.form.cantidad_seis == '0')
      {
        this.error = true;
        this.error_msg =
          "Complete todos los campos";
        return;
      }

      let json = {
        cantidad_dos: this.form.cantidad_dos,
        cantidad_cuatro: this.form.cantidad_cuatro,
        cantidad_seis: this.form.cantidad_seis,
        duracion_dos: this.form.duracion.replace(":","."),
        duracion_cuatro:this.form.duracion.replace(":","."),
        duracion_seis: this.form.duracion.replace(":","."),
        usuario_email: localStorage.getItem("email"),
      };
      console.log(json);
      axios
        .post("/registrarMesa", json)
        .then((data) => {
          if (data.status == 200) {
            this.success = true;
            this.success_msg = "Mesas registradas con exito!";
            this.error = false;
            this.cargarMesas();
          } else {
            this.error = true;
            this.error_msg =
              "No se ha podido registrar las mesas, vuelva a intentar mas tarde.";
          }
        });
    },
    goToPageFirstTime(page) {
      this.$router.push({ name: page, params: { firstTime: true } });
    },
    goToPage(page, $event) {
      this.$router.push({ name: page});
      $event?.preventDefault();
    },
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.col-form-label{
    text-align: left;
}
.btn-primary{
  margin: 15px;
}
</style>
